import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-h-[80vh]" }
const _hoisted_2 = { class: "tw-flex tw-w-full tw-justify-start tw-gap-2 tw-pl-2" }
const _hoisted_3 = {
  key: 0,
  class: "tw-flex tw-h-8 tw-items-center tw-rounded-md tw-py-1 tw-text-xs tw-font-medium"
}

import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { VideoUploadContext } from './utils';
import { type VideoAsset, type VideoLibrarySortOrder } from './videoLibraryService';
import VideoLibraryTable, { VideoLibraryWorkspaceFilter } from './VideoLibraryTable/VideoLibraryTable.vue';

import StudioDialog from '@/studioComponents/StudioDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryTableDialog',
  props: {
    initialSelectedVideoAssets: { default: () => [] },
    selectable: { type: Boolean, default: true },
    maxSelections: { default: Infinity },
    context: { default: '' }
  },
  emits: ["close", "select-videos"],
  setup(__props: any, { emit }) {

const props = __props;



const route = useRoute();
const store = useStore();



const currentPage = ref(1);
const sortOrder = ref<VideoLibrarySortOrder>('-created_at');
const search = ref('');

const videoLibraryTable = ref<InstanceType<typeof VideoLibraryTable>>();

const currentSelectedVideoAssets = computed(() => videoLibraryTable.value?.selectedVideoAssets || []);

const selectedText = computed(() => {
  if (!props.selectable) {
    return '';
  }

  if (props.maxSelections === 1) {
    return '';
  }

  return `Selected: ${currentSelectedVideoAssets.value.length} ${
    props.maxSelections < Infinity ? `of ${props.maxSelections}` : ''
  }`;
});

const workspaceFilter = computed<VideoLibraryWorkspaceFilter>(() => {
  let filter: VideoLibraryWorkspaceFilter = { id: undefined, hidden: false };

  let workspaceId;
  if (route.params.seriesId) {
    const series = store.getters['studioSeriesList/getCurrentSeriesById'](route.params.seriesId);
    if (series?.type === 'repeating') {
      workspaceId = store.getters['studioEventList/getCurrentEvent']?.workspace?.id;
    }
  } else if (route.params.eventId) {
    workspaceId = store.getters['studioEventList/getCurrentEvent']?.workspace?.id;
  } else if (route.params.templateId) {
    workspaceId = store.getters['studioTemplateList/getCurrentTemplate']?.workspace?.id;
  }

  if (workspaceId) {
    filter = { id: workspaceId, hidden: !!workspaceId };
  }

  return filter;
});

const handleSave = () => {
  emit('select-videos', videoLibraryTable.value?.selectedVideoAssets || []);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StudioDialog, {
    title: _ctx.maxSelections === 1 ? 'Select Video' : 'Select Videos',
    size: "2xlarge",
    primaryActionTitle: _ctx.selectable ? 'Save' : '',
    onPrimaryAction: handleSave,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, {
    "footer-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (selectedText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(selectedText.value), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(VideoLibraryTable, {
          ref_key: "videoLibraryTable",
          ref: videoLibraryTable,
          context: _ctx.context,
          selectable: _ctx.selectable,
          currentPage: currentPage.value,
          sortOrder: sortOrder.value,
          search: search.value,
          maxSelections: _ctx.maxSelections,
          initialSelectedVideoAssets: _ctx.initialSelectedVideoAssets,
          series: [],
          events: [],
          tags: [],
          pageSize: 25,
          sources: [],
          createdBy: [],
          workspaceFilter: workspaceFilter.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (currentPage.value = $event)),
          "onUpdate:sortOrder": _cache[1] || (_cache[1] = ($event: any) => (sortOrder.value = $event)),
          "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => (search.value = $event))
        }, null, 8, ["context", "selectable", "currentPage", "sortOrder", "search", "maxSelections", "initialSelectedVideoAssets", "workspaceFilter"])
      ])
    ]),
    _: 1
  }, 8, ["title", "primaryActionTitle"]))
}
}

})